/**
 * threeKernel — Named Three.js constructors for the live THREE bag.
 * Tree-shaken; VFX/overlays must not assume a full `import * as THREE`.
 * Contract: tests/presentation/threeKernelContract.test.js scans `THREE.Foo` usage.
 */
import {
  AdditiveBlending,
  BoxGeometry,
  CircleGeometry,
  ConeGeometry,
  CylinderGeometry,
  DoubleSide,
  Group,
  Mesh,
  MeshBasicMaterial,
  MeshStandardMaterial,
  Plane,
  PlaneGeometry,
  PointLight,
  RingGeometry,
  SphereGeometry,
  TorusGeometry,
  Vector3
} from 'three';

export const THREE_KERNEL = {
  AdditiveBlending,
  BoxGeometry,
  CircleGeometry,
  ConeGeometry,
  CylinderGeometry,
  DoubleSide,
  Group,
  Mesh,
  MeshBasicMaterial,
  MeshStandardMaterial,
  Plane,
  PlaneGeometry,
  PointLight,
  RingGeometry,
  SphereGeometry,
  TorusGeometry,
  Vector3
};
